module.exports = __webpack_public_path__ + "media/images/payments/giropay-37c19e99ab465c891c4eaf7d063ddd34.svg";